import React, { useState, useEffect } from 'react';
//import { useParams } from "react-router-dom";
import { Link } from 'react-router-dom';
import NavbarBottom from './NavbarBottom';


function AnggotaJdih() {
    //const params = useParams();
    const [newsDetail, SetNewsDetail] = useState([]);
    //const urlImg = `${process.env.REACT_APP_BASEURL}/images/news/`;

    /*function handleScroll() {
        const element = document.getElementById('targetElement');
        const offset = 10;
        const bodyRect = document.body.getBoundingClientRect().top;
        const elementRect = element.getBoundingClientRect().top;
        const elementPosition = elementRect - bodyRect;
        const offsetPosition = elementPosition - offset;

        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth'
        });

    }*/

    const sampleData = [
        { name: "John", age: 28, city: "New York" },
        { name: "Jane", age: 32, city: "Chicago" },
        { name: "Mike", age: 36, city: "Los Angeles" },
        { name: "Anna", age: 22, city: "Miami" },
        { name: "Tom", age: 40, city: "Seattle" },
          ];

    function sanitizeUrl(url) {
        return url.replaceAll('&amp;', '&')
    }

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_ENDPOINT}/anggota-jdih`)
            .then((res) => {
                return res.json();
            })
            .then((datas) => {
                //console.log(datas.data);
                SetNewsDetail(datas.data);
            });

        //handleScroll();
        //console.log(newsDetail);
    }, []);

    const getLang = localStorage.getItem('lang_code');

    return (
        <>
            <NavbarBottom />
            <div className="p-4 bg-[#e9f3fd]">
                <div class="flex flex-wrap justify-between">
                    {/*<div class="w-full md:w-3/12 px-4 mb-8">
                        <div class="bg-gray-100 px-4 py-6">
                            <h3 class="font-bold text-left" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 18 }}>
                                <span class="text-[#000]">
                                    {getLang === 'id' ? 'PROFIL KAMI' : 'PROFIL KAMI'}
                                </span>
                            </h3>
                        </div>
                        <div class="flex flex-col divide-y dark:divide-gray-300 bg-white px-4" style={{ fontFamily: 'MuseoSansRounded900', fontSize: 14 }}>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/about">
                                        Visi Misi
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/dasar-hukum">
                                        Dasar Hukum
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/struktur-organisasi">
                                        Struktur Organisasi Bagian Hukum
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/anggota-jdih">
                                        Anggota JDIH Kota Magelang
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/anggota-jdih">
                                        Anggota JDIH Kota Magelang
                                    </Link>
                                </div>
                            </div>
                            <div class="flex px-1 py-4">
                                <div class="flex flex-col flex-grow">
                                    <Link to="/sop-jdih">
                                        SOP
                                    </Link>
                                </div>
                            </div>
                        </div>


                    </div>*/}

                    <div class="bg-white w-full px-4 mb-8 rounded">
                        <div class="w-full h-auto bg-white p-2">
                            <h2 class="text-xl font-semibold text-[#111827] mb-4">Anggota JDIH Kota Magelang</h2>
                            <div class="overflow-hidden border border-[#e5e7eb] rounded-lg">
                                <table class="min-w-full divide-y divide-[#e5e7eb]">
                                    <thead class="bg-[#f9fafb]">
                                        <tr>
                                            <th class="px-6 py-3 text-left text-xs font-semibold text-[#6b7280] uppercase">No</th>
                                            <th class="px-6 py-3 text-left text-xs font-semibold text-[#6b7280] uppercase">Nama Perangkat Daerah</th>
                                            <th class="px-6 py-3 text-left text-xs font-semibold text-[#6b7280] uppercase">Website</th>
                                        </tr>
                                    </thead>
                                    <tbody class="bg-white divide-y divide-[#e5e7eb]">
                                        {newsDetail?.map((field, index) => {
                                            return (
                                                <>
                                                    <tr>
                                                        <td class="px-6 py-4 text-[#111827] font-semibold text-[12px]">{index+1}</td>
                                                        <td class="px-6 py-4 text-[#111827] text-[12px]">{field.nama}</td>
                                                        <td class="px-6 py-4 text-[#111827] text-[12px]">
                                                            <a href={field.website} target='_blank'>{field.website}</a>
                                                        </td>
                                                    </tr>
                                                </>
                                            );
                                        })}
                                    </tbody>
                                </table>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>
    );
}

export default AnggotaJdih;
